<mat-expansion-panel #panel class="expansion-panel-review" hideToggle [expanded]="expanded">
    <mat-expansion-panel-header>
        <div class="field-name">
            <div class="card-title">
                {{ positionName || ('POSITION_DATA.POSITION_DATA' | translate) }}
            </div>
        </div>
        <div class="card-actions">
            <button mat-flat-button color="primary" class="review-button bt-long-text">
                <mat-icon *ngIf="!panel.expanded" >keyboard_arrow_down</mat-icon> 
                <mat-icon *ngIf="panel.expanded">keyboard_arrow_up</mat-icon> 
                {{ 'POSITION_DATA.DETAILS' | translate }}
            </button>
        </div>
    </mat-expansion-panel-header>
    <div [formGroup]="mainForm" class="card-content text-subtitle">

        <mat-form-field appearance="outline" class="w100">
            <mat-label>{{ 'POSITION_DATA.NAME' | translate }}</mat-label>
            <input matInput formControlName="name" autocomplete="off" [disableControl]="!isAllowEdit">
            <mat-error msg></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-max">
            <mat-label>{{ 'POSITION_DATA.DESCRIPTION' | translate }}</mat-label>
            <textarea matInput rows="3" autocomplete="off" formControlName="description" [disableControl]="!isAllowEdit"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-max">
            <mat-label>{{ 'POSITION_DATA.POSITION_PROFILE_DESCRIPTION' | translate }}</mat-label>
            <textarea matInput rows="3" autocomplete="off" formControlName="profilesDescription" [disableControl]="!isAllowEdit"></textarea>
        </mat-form-field>
    </div>
</mat-expansion-panel>
